import { megaMenu, megaMenuResize } from '../__header/MegaMenu';
import Video from '../__utils/video';
import { smoothScroll, pageLoadSmoothScroll } from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import Forms from '../__utils/forms';
import viewportUnits from '../__utils/viewportUnits';
import AlertBar from '../__header/AlertBar';
import sectionsInView from '../__page/sectionsInView';
import clickToPrint from '../__utils/clickToPrint';
import fitText from '../__page/fitText';
import passwordLogout from '../__page/passwordLogout';
import {
	backgroundVideo,
	setBackgroundVideoSize,
} from '../__utils/backgroundVideo';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		megaMenu();
		Video.init();
		smoothScroll();
		pageLoadSmoothScroll();
		Tables.init();
		viewportUnits();
		AlertBar();
		sectionsInView();
		clickToPrint();
		fitText();
		passwordLogout();
		backgroundVideo();
	},
	loaded() {
		document.querySelector('body').classList.add('page-has-loaded');
		Forms();
		viewportUnits();
	},
	resized() {
		megaMenuResize();
		Tables.toggleShadow();
		viewportUnits();
		fitText();
		setBackgroundVideoSize();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
